"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetSnackbarSystemData = resetSnackbarSystemData;
exports.setSnackbarSystemData = setSnackbarSystemData;
exports.setSnackbarSystemDataAlertError = setSnackbarSystemDataAlertError;
exports.setSnackbarSystemDataAlertInfo = setSnackbarSystemDataAlertInfo;
exports.setSnackbarSystemDataAlertSuccess = setSnackbarSystemDataAlertSuccess;
var _configureStore = require("../configureStore");
var ActionTypes = _interopRequireWildcard(require("./ActionTypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// helper function to set alert snackbars - set an Error message
// message: String - Required - The message to display
function setSnackbarSystemDataAlertError(message) {
  var data = {
    alert: 'error',
    message: message,
    open: true
  };
  (0, _configureStore.dispatch)(setSnackbarSystemData(data));
}

// helper function to set alert snackbars - set an Info message
// message: String - Required - The message to display
function setSnackbarSystemDataAlertInfo(message) {
  var data = {
    alert: 'info',
    message: message,
    open: true
  };
  (0, _configureStore.dispatch)(setSnackbarSystemData(data));
}

/**
 * Helper function to set alert snackbars - set a Success message
 * @param {String} message - The message to display
 */
function setSnackbarSystemDataAlertSuccess(message) {
  var data = {
    alert: 'success',
    message: message,
    open: true
  };
  (0, _configureStore.dispatch)(setSnackbarSystemData(data));
}

// Reset the snackbar data to empty
function resetSnackbarSystemData() {
  (0, _configureStore.dispatch)(setSnackbarSystemData({}));
}

// root snackbar set system
// use this one if you need to set more settings
// data: {} - Required - The data to set to display in the VNSnackbar
function setSnackbarSystemData(data) {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.VNSNACKBAR_SYSTEM_SET_DATA,
      snackbarData: data
    });
  };
}